import { render, staticRenderFns } from "./ValidationDetail.vue?vue&type=template&id=525c6241"
import script from "./ValidationDetail.vue?vue&type=script&lang=ts"
export * from "./ValidationDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports